
//Home Car Images
import Golf6 from "../../assets/cars-big/golf6.jpg"
import AudiA1 from "../../assets/cars-big/audia1.jpg";
import Toyota from "../../assets/cars-big/toyotacamry.jpg";
import Bmw320 from "../../assets/cars-big/bmw320.jpg";
import Benz from "../../assets/cars-big/benz.jpg";
import Passat from "../../assets/cars-big/passatcc.jpg";

//Car Catalogue Car Images
import Golf6box from "../../assets/cars-big/golf6-box.png"
import AudiA1box from "../../assets/cars-big/audi-box.png";
import Toyotabox from "../../assets/cars-big/toyota-box.png";
import Bmw320box from "../../assets/cars-big/bmw-box.png";
import Benzbox from "../../assets/cars-big/benz-box.png";
import Passatbox from "../../assets/cars-big/passat-box.png";


export const CAR_DATA = [
  [
    {
      name: "VW Golf 6",
      price: "37",
      img: Golf6,
      boximg: Golf6box,
      model: "Golf 6",
      mark: "Volkswagen",
      year: "2008",
      doors: "4/5",
      air: "Yes",
      transmission: "Manual",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "Audi A1 S-Line",
      price: "45",
      img: AudiA1,
      boximg: AudiA1box,
      model: "Audi",
      mark: "A1",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Manual",
      fuel: "Gasoline",
    },
  ],
  [
    {
      name: "Toyota Camry",
      price: "30",
      img: Toyota,
      boximg:Toyotabox,
      model: "Camry",
      mark: "Toyota",
      year: "2006",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Hybrid",
    },
  ],
  [
    {
      name: "BMW 320 ModernLine",
      price: "35",
      img: Bmw320,
      boximg:Bmw320box,
      model: "320",
      mark: "BMW",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Manual",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "Mercedes-Benz GLK",
      price: "50",
      img: Benz,
      boximg:Benzbox,
      model: "Benz GLK",
      mark: "Mercedes",
      year: "2006",
      doors: "4/5",
      air: "Yes",
      transmission: "Manual",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "VW Passat CC",
      price: "25",
      img: Passat,
      boximg:Passatbox,
      model: "Passat CC",
      mark: "Volkswagen",
      year: "2008",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Gasoline",
    },
  ],
];
